import { useRef } from 'react'

import axios, { CancelTokenSource } from 'axios'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'

import type ReportStruct from 'modules/reports/lib/ReportStruct'
import type { Variable } from 'modules/reports/store/models/Report'

export const useContent = () => {
  const cancelToken = useRef<CancelTokenSource>()

  const fetchReportData = useUnsafeCallback(
    async (reportStruct: ReportStruct, variables: Variable[]) => {
      if (cancelToken.current) {
        cancelToken.current.cancel()
      }

      const token = axios.CancelToken.source()

      cancelToken.current = token

      const data = await reportStruct.generate(variables, token)

      return data
    },
    [cancelToken]
  )

  return {
    fetchReportData,
  }
}
